export default __webpack_public_path__ + "static/media/USK_16.d0e10a4d.png";